export const notificationKeys = {
  all: ['notifications'],
  list: (params: any) => ['notifications', 'list', params],
  detail: (id: any) => ['notifications', 'detail', id],
};
